import { Injector, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PROJECT_CONFIG } from '../project-config';
import { environment } from '../environments/environment';
import { LayoutServicesModule } from '@tangilla/tg-ng-layout';
import { CoreServicesModule } from '@tangilla/tg-ng-core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS, MatSnackBarModule } from '@angular/material/snack-bar';
import { PaymentServicesModule } from '@tangilla/tg-ng-payments';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { FormsApiCallsInterceptor } from './core/interceptors/forms-api-calls.interceptor';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { NGX_LOCAL_STORAGE_CONFIG } from 'ngx-localstorage';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    MatSnackBarModule,
    MatDialogModule,
    MatMenuModule,
    MatTooltipModule,
    MatBottomSheetModule,
    CoreServicesModule.forRoot(environment, PROJECT_CONFIG),
    LayoutServicesModule.forRoot(environment, PROJECT_CONFIG),
    PaymentServicesModule.forRoot(environment, PROJECT_CONFIG)
  ],
  providers: [
    {provide: HTTP_INTERCEPTORS, useClass: FormsApiCallsInterceptor, multi: true},
    {provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: {duration: 5000}},
    {
      provide: NGX_LOCAL_STORAGE_CONFIG,
      useValue: {
        storageType: 'sessionStorage'
      }
    },
    provideEnvironmentNgxMask()
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  static injector: Injector;

  constructor(injector: Injector) {
    AppModule.injector = injector;
  }
}
